const MIN_VISIBLE_MS = 600;
const MAX_VISIBLE_MS = 4500;

let hideScheduled = false;

export function removeAppPreloader() {
  const el = document.getElementById('app-preloader');
  if (!el) return;

  let settled = false;
  const finish = () => {
    if (settled) return;
    settled = true;
    el.removeEventListener('transitionend', onTransitionEnd);
    window.clearTimeout(fallback);
    el.remove();
  };

  const onTransitionEnd = (e) => {
    if (e.target === el && e.propertyName === 'opacity') finish();
  };

  el.setAttribute('aria-busy', 'false');
  el.classList.add('app-preloader--exit');
  el.addEventListener('transitionend', onTransitionEnd);
  const fallback = window.setTimeout(finish, 500);
}

/**
 * Hide logo preloader after app init (or max wait). Avoids a second stuck spinner overlay.
 */
export function initAppPreloader() {
  if (hideScheduled) return;
  hideScheduled = true;

  const shownAt = performance.now();
  let done = false;

  const hide = () => {
    if (done) return;
    const elapsed = performance.now() - shownAt;
    const delay = Math.max(0, MIN_VISIBLE_MS - elapsed);
    window.setTimeout(() => {
      if (done) return;
      done = true;
      removeAppPreloader();
    }, delay);
  };

  window.addEventListener('zaynic:app-ready', hide, { once: true });
  window.setTimeout(hide, MAX_VISIBLE_MS);
}

export function notifyAppReady() {
  window.dispatchEvent(new Event('zaynic:app-ready'));
}
